import { z } from 'zod/v3';
import { DataVersionStatusSchema, ProcessingSchema } from '../../input-data';

export const OutputDataObjectProcessingUpdateSchema = z.object({
  id: z.number().int(),
  standaloneDataObjectDescriptionId: z.number().int().nullable(),
  dataObjectGroupId: z.number().int(),
  dueDateTime: z.string().nullable(),
  confidential: z.boolean(),
  processing: ProcessingSchema.nullable(),
  lastProcessingEndTime: z.string().nullable(),
  loadSampleErrorLevelId: z.number().int().nullable(),
  imputeErrorLevelId: z.number().int().nullable(),
  loadDataErrorLevelId: z.number().int().nullable(),
  subjectCountInData: z.number().int().nullable(),
  subjectCountInSample: z.number().int().nullable(),
  collectionRatio: z.number().nullable(),
  responsibleUserId: z.number().int().nullable(),
  responsibleUserUsername: z.string().nullable(),
  responsibleUserFirstName: z.string().nullable(),
  responsibleUserLastName: z.string().nullable(),
  hasAccess: z.boolean(),
  latestDataObjectVersionId: z.number().int().nullable(),
  versionStatus: DataVersionStatusSchema.nullable(),
  version: z.string().nullable(),
  versionConfirmed: z.boolean(),
  processingStateCode: z.string().nullable(),
  versionValidationErrorLevelId: z.number().int().nullable(),
  calculationErrors: z.boolean(),
  missingSourceData: z.boolean(),
});

export const OutputDataObjectProcessingUpdatesSchema = z.array(
  OutputDataObjectProcessingUpdateSchema,
);
